export enum MarquisPattern {
  SINGLE_COLOR = 'enfargad',
  BLOCK_STRIPED = 'blockrandig',
  STRIPED = 'randig',
  ALL = 'alla',
}
